<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-3"></a>
<div class="img_containerrr"><img alt="image" class="width" src="images/Img_1_001.jpg"/></div>
<h1 class="title1"><span class="bold">AIR WAR ON THE EASTERN FRONT</span></h1>
<h2 class="author"><span class="bold">MIKE GUARDIA</span></h2>
<div class="img_container"><img alt="image" src="images/Img_3_001.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002_Title_page.vue?38781da9